import MapGeozones from './MapGeozones'

export default MapGeozones;
